import React, { useState } from "react";
import {
  Layout,
  Breadcrumb,
  Button,
  Table,
  Row,
  Spin,
  Card,
  Col,
  DatePicker,
  message,
} from "antd";
import { FileExcelOutlined, SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import { APPBACKGROUND_COLOR, MAINAPIURL } from "../../appsettings";
import { AlertError } from "../../usableclasses";
import Headerdiv from "../../layout/header";
import Footerdiv from "../../layout/footer";
import { handleDailySaleReportExcelExport } from "./daily-sale-report-excel";
import { render } from "@testing-library/react";
import { Link } from "react-router-dom";

const { Content } = Layout;
const { RangePicker } = DatePicker;

const columns = [
  { title: "Order Date", dataIndex: "orderDate", key: "orderDate", align: "center", render: (text) => dayjs(text).format("YYYY-MM-DD") },
  { title: "Orders Count", dataIndex: "ordersCount", align: "center" },
  { title: "Product Total", dataIndex: "productTotal", key: "productTotal", align: "right" },
  { title: "Shipping Total", dataIndex: "shippingTotal", key: "shippingTotal", align: "right" },
  { title: "Handling Fee", dataIndex: "handlingFeeTotal", key: "handlingFeeTotal", align: "right" },
  { title: "Order Total", dataIndex: "orderTotal", key: "orderTotal", align: "right" },
  { title: "BV Total", dataIndex: "bvTotal", key: "bvTotal", align: "right" },
  { title: "CP Total", dataIndex: "cpTotal", key: "cpTotal", align: "right" }
];

const DailySaleReport = () => {
  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");
  const [isLoading, setIsLoading] = useState(false);
  const [saleItems, setSaleItems] = useState([]);
  const [dateRange, setDateRange] = useState([]);

  const fetchSaleItems = async () => {
    if (!dateRange || dateRange.length !== 2) {
      message.warning("Please select a date range first.");
      return;
    }

    try {
      setIsLoading(true);
      const headers = { SystemAccessToken: TOKEN };
      const payload = {
        startDate: dayjs(dateRange[0]).format("YYYY-MM-DD"),
        endDate: dayjs(dateRange[1]).format("YYYY-MM-DD"),
      };

      const response = await axios.post(
        `${ApiURL}/reports/sales/dailysalessummarybydaterange`,
        payload,
        { headers }
      );
      setSaleItems(response.data);
    } catch (error) {
      AlertError("Failed to Load Sale Report Items");
    } finally {
      setIsLoading(false);
    }
  };

  const handleExcelExport = () => {
    handleDailySaleReportExcelExport(saleItems);
  };

  return (
    <Spin spinning={isLoading} tip="Processing...">
      <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
        <Headerdiv />
        <Content style={{ padding: "10px" }}>
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item><Link to={"/reports"}>Reports</Link></Breadcrumb.Item>
            <Breadcrumb.Item>Daily Sale Report</Breadcrumb.Item>
          </Breadcrumb>

          <Card title={
            <Row justify="space-between" align="middle">
              <Col>Daily Sale Report</Col>
              <Col>
                <Button
                  disabled={saleItems.length === 0}
                  type="primary"
                  icon={<FileExcelOutlined />}
                  onClick={handleExcelExport}
                  style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                >
                  Export to Excel
                </Button>
              </Col>
            </Row>
          } style={{ marginBottom: 20 }}>
            <Row gutter={16} justify="flex-start" align="middle" style={{ marginBottom: 16 }}>
              <Col>
                <RangePicker
                  format="YYYY-MM-DD"
                  onChange={(dates) => setDateRange(dates)}
                />
              </Col>
              <Col>
                <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={fetchSaleItems}
                  loading={isLoading}>
                  Get Data
                </Button>
              </Col>
            </Row>
          </Card>

          <Card title="Daily Sales Summary Report" style={{ marginBottom: 20 }}>
            <Table
              columns={columns}
              dataSource={saleItems}
              pagination={false}
              bordered
              scroll={{ x: "max-content" }}
              rowKey="saleId"
            />
          </Card>
        </Content>
        <Footerdiv />
      </Layout>
    </Spin>
  );
};

export default DailySaleReport;
